import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { api } from '../../services/api';
import { useAuthStore } from '../../store/authStore';
import { claudeMarkIds, isClaudeMarked } from '../../utils/claudeConnect';

export { isClaudeMarked };

/**
 * FIX-CLAUDE-B (D-314 §11) — which of these records were made through Claude
 * (attendance event, log, status change, message). OTE employees only: for
 * anyone else (a customer in the portal) nothing is asked and nothing is shown.
 */
export function useClaudeMarks(ids: ReadonlyArray<string | null | undefined>): Set<string> {
  const isEmployee = useAuthStore((s) => s.user?.is_ote_employee === true);
  const key = claudeMarkIds(ids);
  const q = useQuery({
    queryKey: ['claude-marks', key.join(',')],
    queryFn: () => api.getClaudeMarks(key),
    enabled: isEmployee && key.length > 0,
    staleTime: 30_000,
  });
  const marked = q.data?.data?.ids;
  return useMemo(() => new Set((marked ?? []).map((x) => x.toLowerCase())), [marked]);
}
